import { render, staticRenderFns } from "./TallyCounter.vue?vue&type=template&id=5515dbdf&scoped=true&"
import script from "./TallyCounter.vue?vue&type=script&lang=ts&"
export * from "./TallyCounter.vue?vue&type=script&lang=ts&"
import style0 from "./TallyCounter.vue?vue&type=style&index=0&id=5515dbdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5515dbdf",
  null
  
)

export default component.exports